<template>
	<RectangleTile class="active-wheel-reward-tile">


		<template v-slot:icon>
			<TileIcon :size="52" class="active-wheel-reward-tile__icon">
				<img src="/assets/GreenBolt.svg" alt="Spin the Wheel" />
			</TileIcon>
		</template>

		<template v-slot:details>
			<TileDetails>
				<template v-slot:name>
					<div class="active-wheel-reward-tile__title">{{ reward.text }}</div>
				</template>
				<template v-slot:description>
					<div class="active-wheel-reward-tile__timer" v-if="!reward.is_expired">
						<WheelTimer :endTime="reward.expires_at" class="spin-the-wheel__timer--transparent" />
					</div>
					<div v-else class="active-wheel-reward-tile__expired">
						Expired
					</div>
				</template>
			</TileDetails>

		</template>

	</RectangleTile>
</template>



<script setup>

import TileIcon from '@/components/Common/Tile-Icon.vue';
import TileDetails from '@/components/Common/Tile-Details.vue';
import RectangleTile from '@/components/Tiles/Rectangle-Tile.vue';
import WheelTimer from '@/components/SpinTheWheel/WheelTimer.vue';

const props = defineProps({
    reward: {
        type: Object,
        required: true
    }
});

</script>